const API_CONFIG = {
  BASE_URL: 'https://snap-url.onrender.com/api',
  //  BASE_URL: 'http://localhost:8091/api',
};

class UrlService {
  constructor() {
    this.baseUrl = API_CONFIG.BASE_URL;
    this.endpoints = API_CONFIG.ENDPOINTS;
  }

  async shortenUrl(longUrl) {
    try {
      const response = await fetch(`${this.baseUrl}/shorten`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ longUrl }),
        credentials: 'include',
      });
  
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to shorten URL');
      }
  
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async redirectToLongUrl(shortCode) {
    if (!shortCode) {
        throw new Error('Short code is required');
    }

    try {
        const response = await fetch(`${this.baseUrl}/${shortCode}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch redirect URL');
        }

        const data = await response.json();
        
        if (!data || !data.longUrl) {
            throw new Error('Invalid URL data received');
        }

        // Ensure the URL is properly formatted
        const urlToRedirect = data.longUrl.startsWith('http') 
            ? data.longUrl 
            : `https://${data.longUrl}`;

        return urlToRedirect; // Return the URL instead of redirecting here
    } catch (error) {
        console.error('Redirect error:', error);
        throw error;
    }
}


  
  
  
}

export default new UrlService();
